module.exports = __webpack_public_path__ + "resources/back-e8e05e7c043b2bf3ccd177b4539fc31c.svg";